const TRANSIENT_AUTH_ERRORS = new Set(['timeout', 'network_error', 'fetch_error', 'failed_to_fetch'])

export function needsInteractiveLogin(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) {
    return false
  }
  const authError = error as { error?: string }
  switch (authError.error) {
    case 'login_required':
    case 'consent_required':
    case 'interaction_required':
    case 'invalid_grant':
    case 'missing_refresh_token':
      return true
    default:
      return false
  }
}

export function isTransientAuthError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) {
    return false
  }
  const authError = error as { error?: string; message?: string }
  if (authError.error != null && TRANSIENT_AUTH_ERRORS.has(authError.error)) {
    return true
  }
  const message = authError.message
  if (typeof message !== 'string') {
    return false
  }
  return /timeout|network|failed to fetch/i.test(message)
}

export function isUsableAccessToken(token: string, nowMs = Date.now(), skewMs = 60_000): boolean {
  if (token.length === 0 || token === 'undefined') {
    return false
  }
  const parts = token.split('.')
  if (parts.length < 2) {
    return false
  }
  try {
    const normalized = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=')
    const payload = JSON.parse(atob(padded)) as { exp?: unknown }
    return typeof payload.exp === 'number' && payload.exp * 1000 > nowMs + skewMs
  } catch {
    return false
  }
}

export function shouldHydrateUserPermissions(
  tokenHydratedThisSession: string | null,
  nextToken: string
): boolean {
  return tokenHydratedThisSession !== nextToken
}

export const sleep = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms))
